(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cards-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('collection-cards-slider')) return;

    class CollectionCardsSlider extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.track?.classList.remove(
          'is-dragging',
          'is-scrollbar-dragging',
          'is-free-scrolling',
          'is-programmatic-scrolling'
        );
      }

      onClick(event) {
        if (!this.suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }

      onResize() {
        this.updateScrollable();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--collection-cards-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX);
      }

      scrollToScrollbarPosition(clientX) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--collection-cards-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        this.animateScrollTo(maxScroll * progress);
      }

      animateScrollTo(targetLeft) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const duration = 400;
        const startTime = performance.now();

        this.isScrollbarScrolling = true;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);

          this.track.scrollLeft = startLeft + distance * easedProgress;
          this.scrollbar.value = maxScroll > 0
            ? String((this.track.scrollLeft / maxScroll) * 100)
            : '0';

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const track = event.target.closest('[data-track]');
        if (!track || !this.contains(track) || track.scrollWidth <= track.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activePointerId = event.pointerId;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = track.scrollLeft;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.track || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.track || event.pointerId !== this.activePointerId) return;

        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-track]')) event.preventDefault();
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (this.controls) this.controls.hidden = !isScrollable;
          this.updateControls();
        });
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
      }
    }

    customElements.define('collection-cards-slider', CollectionCardsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-select-product-grid"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-product-tabs')) return;

    class CollectionProductTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onGridChange = this.onGridChange.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-tabs]');
        this.section = this.closest('[data-collection-grid]');
        this.gridContainer = this.section?.querySelector('[data-product-grid-container]');
        this.activeFilter = 'all';

        this.addEventListener('click', this.onClick);
        this.track?.addEventListener('pointerdown', this.onPointerDown);
        this.track?.addEventListener('dragstart', this.onDragStart);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.tabsResizeObserver = new ResizeObserver(this.onResize);
        if (this.track) this.tabsResizeObserver.observe(this.track);

        if (this.gridContainer) {
          this.gridObserver = new MutationObserver(this.onGridChange);
          this.gridObserver.observe(this.gridContainer, { childList: true, subtree: true });
        }

        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('pointerdown', this.onPointerDown);
        this.track?.removeEventListener('dragstart', this.onDragStart);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        this.tabsResizeObserver?.disconnect();
        this.gridObserver?.disconnect();
        window.clearTimeout(this.clickResetTimer);
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          this.suppressClick = false;
          return;
        }

        const tab = event.target.closest('[data-tab]');
        if (!tab || !this.contains(tab)) return;

        this.querySelectorAll('[data-tab]').forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });

        this.activeFilter = tab.dataset.filter;
        this.filterProducts();
      }

      onResize() {
        this.updateScrollable();
      }

      onGridChange() {
        this.filterProducts();
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch' || !this.track?.classList.contains('is-scrollable')) return;

        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = this.track.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) this.track.setPointerCapture(event.pointerId);
        this.hasDragged = true;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId !== this.activePointerId) return;

        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      filterProducts() {
        const cards = this.section?.querySelectorAll('[data-product-card]') || [];
        let visibleCount = 0;

        cards.forEach((card) => {
          const isVisible = this.activeFilter === 'all' || card.dataset.productTitle.includes(this.activeFilter);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        const emptyMessage = this.section?.querySelector('[data-tabs-empty]');
        if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (!isScrollable) this.track.scrollLeft = 0;
        });
      }
    }

    customElements.define('collection-product-tabs', CollectionProductTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('customer-reviews')) return;

    class CustomerReviews extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.updateLayout();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateLayout();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.activeScroller?.classList.remove('is-dragging');
        this.track?.classList.remove('is-scrollbar-dragging', 'is-free-scrolling', 'is-programmatic-scrolling');
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const readMoreButton = event.target.closest('[data-read-more]');
        if (readMoreButton && this.contains(readMoreButton)) {
          this.toggleReview(readMoreButton);
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollReviews(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) this.scrollReviews(1);
      }

      onResize() {
        this.updateLayout();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--customer-reviews-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX);
      }

      scrollToScrollbarPosition(clientX) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--customer-reviews-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        this.animateScrollTo(maxScroll * progress, 400, true);
      }

      scrollReviews(direction) {
        if (!this.track) return;

        const cards = Array.from(this.track.querySelectorAll('[data-card]'));
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const scroller = event.target.closest('[data-scroll]');
        if (!scroller || !this.contains(scroller) || scroller.scrollWidth <= scroller.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activeScroller = scroller;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = scroller.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.activeScroller.setPointerCapture(event.pointerId);
          this.activeScroller.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.activeScroller.classList.add('is-dragging');
        this.activeScroller.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        if (this.activeScroller.hasPointerCapture(event.pointerId)) {
          this.activeScroller.releasePointerCapture(event.pointerId);
        }

        this.activeScroller.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activeScroller = null;
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      toggleReview(button) {
        const review = button.closest('[data-review]');
        if (!review) return;

        const isExpanded = review.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(isExpanded));
        button.textContent = isExpanded ? button.dataset.lessLabel : button.dataset.moreLabel;
        this.dispatchEvent(new CustomEvent('customer-reviews:toggle', {
          bubbles: true,
          detail: { expanded: isExpanded }
        }));
      }

      updateLayout() {
        window.requestAnimationFrame(() => {
          this.updateScrollable();
          this.updateReadMore();
        });
      }

      updateScrollable() {
        if (!this.track) return;

        const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
        this.track.classList.toggle('is-scrollable', isScrollable);
        if (this.controls) this.controls.hidden = !isScrollable;
        this.updateControls();
      }

      updateReadMore() {
        this.querySelectorAll('[data-review]').forEach((review) => {
          if (review.classList.contains('is-expanded')) return;

          const text = review.querySelector('[data-review-text]');
          const button = review.querySelector('[data-read-more]');
          if (!text || !button) return;

          button.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }
    }

    customElements.define('customer-reviews', CustomerReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('icon-text-marquee')) return;

    class IconTextMarquee extends HTMLElement {
      constructor() {
        super();
        this.fillTrack = this.fillTrack.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-icon-text-marquee-viewport]');
        this.groups = Array.from(this.querySelectorAll('[data-icon-text-marquee-group]'));

        if (!this.viewport || this.groups.length !== 2) return;

        if (!this.baseItems) {
          this.baseItems = Array.from(this.groups[1].children).map((item) => item.cloneNode(true));
        }

        this.resizeObserver = new ResizeObserver(this.fillTrack);
        this.resizeObserver.observe(this.viewport);
        this.fillTrack();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      fillTrack() {
        const isDesktopStatic = this.dataset.desktopStatic === 'true' && window.matchMedia('(min-width: 1025px)').matches;

        if (isDesktopStatic) {
          this.querySelectorAll('[data-icon-text-marquee-clone]').forEach((item) => item.remove());
          return;
        }

        if (!this.baseItems?.length) return;

        this.classList.add('icon-text-marquee--measuring');

        let repetitions = 0;
        while (this.groups[0].scrollWidth < this.viewport.clientWidth && repetitions < 50) {
          this.groups.forEach((group, groupIndex) => {
            this.baseItems.forEach((item) => {
              const clone = item.cloneNode(true);
              clone.setAttribute('data-icon-text-marquee-clone', '');

              if (groupIndex === 0) {
                clone.setAttribute('aria-hidden', 'true');
              }

              group.appendChild(clone);
            });
          });
          repetitions += 1;
        }

        this.classList.remove('icon-text-marquee--measuring');
      }
    }

    customElements.define('icon-text-marquee', IconTextMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-products-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('selected-products-tabs')) return;

    class SelectedProductsTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.tabs = this.querySelector('[data-tabs]');
        this.tabsHeader = this.querySelector('[data-tabs-header]');
        this.tabsHeading = this.querySelector('[data-tabs-heading]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.tabsResizeObserver = new ResizeObserver(this.onResize);
        if (this.tabsHeader) this.tabsResizeObserver.observe(this.tabsHeader);
        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        this.tabsResizeObserver?.disconnect();
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.activeScroller?.classList.remove('is-dragging');
        this.track?.classList.remove('is-scrollbar-dragging', 'is-free-scrolling', 'is-programmatic-scrolling');
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const submitButton = event.target.closest('[data-submit]');
        if (submitButton && this.contains(submitButton)) {
          this.addToCart(submitButton);
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollProducts(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) {
          this.scrollProducts(1);
          return;
        }

        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) {
          this.selectTab(tab);
          return;
        }
      }

      selectTab(selectedTab) {
        const filter = selectedTab.dataset.filter;

        this.querySelectorAll('[data-tab]').forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', String(isSelected));
        });

        this.querySelectorAll('[data-card]').forEach((card) => {
          const tags = card.dataset.tags.split(/\s+/).filter(Boolean);
          card.hidden = filter !== 'all' && !tags.includes(filter);
        });

        if (this.track) this.track.scrollLeft = 0;
        this.updateScrollable();
      }

      async addToCart(submitButton) {
        const addToCart = submitButton.closest('[data-selected-product]');
        const errorMessage = addToCart.querySelector('[data-form-error]');
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();

        formData.append('id', submitButton.dataset.variantId);
        formData.append('quantity', '1');

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        errorMessage.hidden = true;

        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const responseText = await response.text();
          let result;

          try {
            result = JSON.parse(responseText);
          } catch (error) {
            throw new Error(window.cartStrings?.error || response.statusText);
          }

          if (!response.ok || result.status) throw new Error(result.description || result.message);

          this.dispatchEvent(new CustomEvent('selected-products:added', {
            bubbles: true,
            detail: { product: result }
          }));

          if (cartDrawer?.renderContents) {
            cartDrawer.setActiveElement(submitButton);
            cartDrawer.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || `${window.Shopify.routes.root}cart`;
          }
        } catch (error) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
          this.dispatchEvent(new CustomEvent('selected-products:error', {
            bubbles: true,
            detail: { message: error.message }
          }));
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }

      onResize() {
        this.updateScrollable();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--selected-products-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX);
      }

      scrollToScrollbarPosition(clientX) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--selected-products-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        this.animateScrollTo(maxScroll * progress, 400, true);
      }

      scrollProducts(direction) {
        if (!this.track) return;

        const cards = Array.from(this.track.querySelectorAll('[data-card]:not([hidden])'));
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const scroller = event.target.closest('[data-scroll]');
        if (!scroller || !this.contains(scroller) || scroller.scrollWidth <= scroller.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activeScroller = scroller;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = scroller.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.activeScroller.setPointerCapture(event.pointerId);
          if (this.activeScroller === this.track) this.activeScroller.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.activeScroller.classList.add('is-dragging');
        this.activeScroller.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        if (this.activeScroller.hasPointerCapture(event.pointerId)) {
          this.activeScroller.releasePointerCapture(event.pointerId);
        }

        this.activeScroller.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activeScroller = null;
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          this.updateTabsScrollable();
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (this.controls) this.controls.hidden = !isScrollable;
          this.updateControls();
        });
      }

      updateTabsScrollable() {
        if (!this.tabs || !this.tabsHeader || !this.tabsHeading) return;

        if (!window.matchMedia('(min-width: 768px)').matches) {
          this.tabs.classList.remove('is-scrollable');
          this.tabsHeader.classList.remove('is-tabs-below');
          return;
        }

        const tabs = Array.from(this.tabs.querySelectorAll('[data-tab]'));
        const gap = Number.parseFloat(window.getComputedStyle(this.tabs).columnGap) || 0;
        const contentWidth = tabs.reduce((width, tab) => width + tab.getBoundingClientRect().width, 0)
          + Math.max(0, tabs.length - 1) * gap;
        const headerGap = Number.parseFloat(window.getComputedStyle(this.tabsHeader).columnGap) || 0;
        const headerWidth = this.tabsHeader.getBoundingClientRect().width;
        const inlineAvailableWidth = headerWidth - this.tabsHeading.getBoundingClientRect().width - headerGap;
        const isBelow = contentWidth > inlineAvailableWidth + 1;
        const availableWidth = isBelow ? headerWidth : inlineAvailableWidth;
        const isScrollable = contentWidth > availableWidth + 1;

        this.tabsHeader.classList.toggle('is-tabs-below', isBelow);
        this.tabs.classList.toggle('is-scrollable', isScrollable);
        if (!isScrollable) this.tabs.scrollLeft = 0;
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }

    }

    customElements.define('selected-products-tabs', SelectedProductsTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
